<div class="modal-content">
    <div class="modal-header">
      <h1 class="modal-title pull-left" id="my-modal-title">{{ title | globalTranslate }}</h1>
      <button type="button" class="btn-close pull-right" [attr.aria-label]="'CLOSE' | globalTranslate" (click)="onCancel()">
        <img src="../../assets/images/⚛️ icons-close-circle-outline.svg" alt="close-icon" />
      </button>
    </div>
    <div class="modal-body">
      <p [innerHTML]="'DOC_UPLOAD_LIMIT_TEXT' | globalTranslate"></p>
    </div>
    <div class="modal-footer">
      <div class="me-2 ml-2">
        <button type="button" id="dialog" class="btn d-grid btn-secondary" (click)="onCancel()">{{
          'OK' | globalTranslate }}</button>
      </div>
    </div>
  </div>